import cart from '../../api/CartRequests.js';

// Some of the available fields from CartController
// const product_structure = {
//   title: null,
//   price: 0,
//   item_id: null,
//   product_id: null,
//   quantity: 1,
//   term: 1,
//   term_type: 'Year',
// };

const state = {
  items: [],
  addon_items: [],
  suggested_addons: [],
  upsell_suggestion: undefined,
  total: 0.0,
  invoice_preview: {},

  removed_item: {},
  undo_option: false
};

const getters = {
  itemCount: state => {
    return state.items.count;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  addCartItem({ state, commit }, { product_id, term, options }) {
    return new Promise((resolve, reject) => {
      cart
        .addCartItem({ product_id, term, options })
        .then(response => {
          commit('setCartItems', response.data.cart_data.cart_contents);
          commit('setCartUpsell', response.data.upsell_suggestion);
          commit('setAddOnItems', response.data.cart_data.cart_addons);
          commit('setCartTotal', response.data.cart_data.cart_total);
          commit('setInvoicePreview', response.data.invoice_preview);
          resolve();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          reject();
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCartItems({ state, commit }, with_addon_suggestions = false) {
    return new Promise((resolve, reject) => {
      cart
        .getCartItems(with_addon_suggestions)
        .then(response => {
          commit('setCartItems', response.data.cart_data.cart_contents);
          commit('setCartUpsell', response.data.upsell_suggestion);
          commit('setAddOnItems', response.data.cart_data.cart_addons);
          commit('setCartTotal', response.data.cart_data.cart_total);
          commit('setInvoicePreview', response.data.invoice_preview);
          resolve();
        })
        .catch(error => {
          // TODO: error handling figure out how to use
          // shortstar/resources/assets/js/classes/errors.js
          console.log(error);
          reject(error.response.data);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateProduct({ state, commit }, { id, product_id, term, quantity, domain, billing_plan_id, term_type }) {
    const product_data = {
      product_id: product_id,
      term: term,
      quantity: quantity,
      domain: domain,
      billing_plan_id: billing_plan_id,
      term_type: term_type
    };

    return new Promise((resolve, reject) => {
      cart
        .updateCartItem(id, product_data)
        .then(response => {
          commit('setCartItems', response.data.cart_data.cart_contents);
          commit('setCartUpsell', response.data.upsell_suggestion);
          commit('setAddOnItems', response.data.cart_data.cart_addons);
          commit('setCartTotal', response.data.cart_data.cart_total);
          commit('setInvoicePreview', response.data.invoice_preview);
          resolve();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // eslint-disable-next-line no-prototype-builtins
          if (error.response.data.hasOwnProperty('cart_data')) {
            // Still need to update cart contents as the id hashes have changed
            // just notify the caller that the request encountered an error
            commit('setCartItems', error.response.data.cart_data.cart_contents);
            commit('setCartUpsell', error.response.data.upsell_suggestion);
            commit('setCartTotal', error.response.data.cart_data.cart_total);
          }

          reject(error.response.data.errors);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateCartGlobalTerm({ state, commit }, { term, item_ids }) {
    cart
      .updateCartGlobalTerm(term, {
        item_ids: item_ids
      })
      .then(response => {
        commit('setCartItems', response.data.cart_data.cart_contents);
        commit('setCartUpsell', response.data.upsell_suggestion);
        commit('setAddOnItems', response.data.cart_data.cart_addons);
        commit('setCartTotal', response.data.cart_data.cart_total);
      })
      .catch(error => {
        // TODO: handle error
        console.log(error);
      });
  },

  // eslint-disable-next-line no-unused-vars
  removeCartItem({ state, commit }, { id }) {
    let removed_item = state.items.find(item => item.id === id);
    commit('setRemovedCartItem', removed_item);

    return new Promise((resolve, reject) => {
      cart
        .removeCartItem(id)
        .then(response => {
          commit('setCartItems', response.data.cart_data.cart_contents);
          commit('setCartUpsell', response.data.upsell_suggestion);
          commit('setAddOnItems', response.data.cart_data.cart_addons);
          commit('setCartTotal', response.data.cart_data.cart_total);
          commit('setInvoicePreview', response.data.invoice_preview);
          commit('setUndoOption', true);
          resolve();
        })
        .catch(error => {
          commit('setUndoOption', false);
          commit('setRemovedCartItem', {});
          reject(error.response.data.errors);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  removeAddOnItem({ state, commit }, { id }) {
    return new Promise((resolve, reject) => {
      cart
        .removeCartItem(id)
        .then(response => {
          commit('setCartItems', response.data.cart_data.cart_contents);
          commit('setCartUpsell', response.data.upsell_suggestion);
          commit('setAddOnItems', response.data.cart_data.cart_addons);
          commit('setCartTotal', response.data.cart_data.cart_total);
          commit('setInvoicePreview', response.data.invoice_preview);
          resolve();
        })
        .catch(error => {
          reject(error.response.data.errors);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  addDiscount({ state, commit }, { coupon_code }) {
    return new Promise((resolve, reject) => {
      cart
        .addDiscount(coupon_code)
        .then(response => {
          commit('setInvoicePreview', response.data.invoice_preview);
          resolve();
        })
        .catch(error => {
          reject(error.response.data.errors);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  undoRemoval({ state, commit }) {
    if (!state.undo_option || !state.removed_item) {
      throw new Error('No changes to undo');
    }

    let removed_item = {
      product_id: state.removed_item.product_id,
      term: state.removed_item.term,
      options: state.removed_item.options
    };

    cart
      .addCartItem(removed_item)
      .then(response => {
        commit('setCartItems', response.data.cart_data.cart_contents);
        commit('setCartUpsell', response.data.upsell_suggestion);
        commit('setCartTotal', response.data.cart_data.cart_total);
        commit('setInvoicePreview', response.data.invoice_preview);
        commit('setUndoOption', false);
        commit('setRemovedCartItem', {});
      })
      // eslint-disable-next-line no-unused-vars
      .catch(error => {
        // TODO
      });
  },

  // eslint-disable-next-line no-unused-vars
  dismissRemovalOption({ state, commit }) {
    commit('setUndoOption', false);
    commit('setRemovedCartItem', {});
  }
};

const mutations = {
  pushProductToCart(state, item) {
    state.items.push(item);
  },

  setCartItems(state, items) {
    state.items = items;
  },

  setCartUpsell(state, suggestion) {
    state.upsell_suggestion = suggestion;
  },

  setAddOnItems(state, add_ons) {
    state.addon_items = add_ons;
  },

  setCartTotal(state, total) {
    state.total = parseFloat(total.replace(',', ''));
  },

  setRemovedCartItem(state, removed_item) {
    state.removed_item = removed_item;
  },

  setUndoOption(state, undo) {
    state.undo_option = undo;
  },

  setInvoicePreview(state, preview) {
    state.invoice_preview = preview;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
